import { InstanceListView } from '@/components/InstanceListView'
import { useInstanceList } from '@/hooks/useInstanceList.tsx'
import { useStorageBillingMode } from '@/hooks/useStorageBillingMode'

export function InstanceListPage() {
  const instanceListState = useInstanceList()
  const { snapshotOnSpaceBilling } = useStorageBillingMode()

  return <InstanceListView {...instanceListState} snapshotOnSpaceBilling={snapshotOnSpaceBilling} />
}
